const PRIVATE_EVENTS = {
  SCORE_CARD_UPDATE: 'SCORE_CARD_UPDATE',
  TEST_START_PRIVATE: 'TEST_START_PRIVATE',
  LEFT_GOAL_UPDATE: 'LEFT_GOAL_UPDATE',
  SCORE_CARD_GOAL_SUMMARY_UPDATE: 'SCORE_CARD_GOAL_SUMMARY_UPDATE',
  SCORECARD_STATS_UPDATE: 'SCORECARD_STATS_UPDATE',
  PENALTY_SHOOT_UPDATE: 'PENALTY_SHOOT_UPDATE',
  FIXTURE_UPDATE: 'FIXTURE_UPDATE',
  FIXTURE_WIDGET_DESTROY: 'FIXTURE_WIDGET_DESTROY',
  FIXTURE_WIDGET_MULTI_DESTROY: 'FIXTURE_WIDGET_MULTI_DESTROY',
  STANDINGS_UPDATE: 'STANDINGS_UPDATE',
  STANDINGS_FULL_PAGE_UPDATE: 'STANDINGS_FULL_PAGE_UPDATE',
  FULL_PAGE_FIXTURE_UPDATE: 'FULL_PAGE_FIXTURE_UPDATE',
  INITIAL_TAB_CONFIG: 'INITIAL_TAB_CONFIG',
  LINE_UP_TEAM_FORMATION_UPDATE: 'LINE_UP_TEAM_FORMATION_UPDATE',
  LINE_UP_HOME_TEAM_DATA_TOP_UPDATE: 'LINE_UP_HOME_TEAM_DATA_TOP_UPDATE',
  LINE_UP_HOME_TEAM_DATA_FORMATION_UPDATE: 'LINE_UP_HOME_TEAM_DATA_FORMATION_UPDATE',
  LINE_UP_HOME_TEAM_DATA_BENCH_UPDATE: 'LINE_UP_HOME_TEAM_DATA_BENCH_UPDATE',
  LINE_UP_HOME_TEAM_DATA_SUBSTITUTE_UPDATE: 'LINE_UP_HOME_TEAM_DATA_SUBSTITUTE_UPDATE',
  LINE_UP_AWAY_TEAM_DATA_TOP_UPDATE: 'LINE_UP_AWAY_TEAM_DATA_TOP_UPDATE',
  LINE_UP_AWAY_TEAM_DATA_FORMATION_UPDATE: 'LINE_UP_AWAY_TEAM_DATA_FORMATION_UPDATE',
  LINE_UP_AWAY_TEAM_DATA_BENCH_UPDATE: 'LINE_UP_AWAY_TEAM_DATA_BENCH_UPDATE',
  LINE_UP_AWAY_TEAM_DATA_SUBSTITUTE_UPDATE: 'LINE_UP_AWAY_TEAM_DATA_SUBSTITUTE_UPDATE',
  LINE_UP_TEAM_MERGE_UPDATE: 'LINE_UP_TEAM_MERGE_UPDATE',
  PLAY_BY_PLAY_DATA_UPDATE: 'PLAY_BY_PLAY_DATA_UPDATE',
  LINEUP_DATA_UPDATE: 'LINEUP_DATA_UPDATE',
  FIXTURES_DATA_UPDATE: 'FIXTURES_DATA_UPDATE',
  LINEUP_SQUAD_READY: 'LINEUP_SQUAD_READY',
  LINEUP_PRE_SCREEN_READY: 'LINEUP_PRE_SCREEN_READY'
};

const PUBLIC_EVENTS = {
  TEST_START_PUBLIC: 'TEST_START_PUBLIC',
  SPORTS_MANAGER_ERROR: 'SPORTS_MANAGER_ERROR',
  SPORTS_MANAGER_SUCCESS: 'SPORTS_MANAGER_SUCCESS',
  TAB_CONFIG_DATA_SUCCESS: 'TAB_CONFIG_DATA_SUCCESS',
  FIXTURES_DATA_UPDATE: 'FIXTURES_DATA_UPDATE',
  STANDINGS_UPDATE: 'STANDINGS_UPDATE',
};

const EVENT_CALLBACK = {
  PUBLIC_EVENTS: 'PUBLIC_EVENTS',
  PRIVATE_EVENTS: 'PRIVATE_EVENTS',
};

export { EVENT_CALLBACK, PUBLIC_EVENTS, PRIVATE_EVENTS };
